import { createSlice } from '@reduxjs/toolkit';
import * as thunks from './thunks';
import selectors from './selectors';
import adapter from './adapter';

const slice = createSlice({
  name: 'invoice',
  initialState: adapter.getInitialState({
    loading: false,
    meta: {},
    /* Null until asked for, so the cart can tell "nothing pending" apart from
       "not looked yet" and avoid deciding on a count it does not have. */
    pendingSummary: null,
  }),
  extraReducers: (builder) => {
    builder
      .addCase(thunks.fetch.pending, (state, action) => {
        state.loading = true;
        adapter.removeAll(state);
      })
      .addCase(thunks.fetch.fulfilled, (state, action) => {
        const { show_all } = action.meta.arg || {};
        const invoices = show_all ? action.payload : action.payload.invoices;

        adapter.setAll(state, invoices);
        state.meta = action.payload.meta || {};
        state.loading = false;
      })
      .addCase(thunks.fetch.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(thunks.fetchPendingSummary.fulfilled, (state, action) => {
        state.pendingSummary = action.payload;
      });
  },
});

const invoice = {
  slice,
  thunks,
  selectors,
};
export default invoice;
